const RTF = new Intl.RelativeTimeFormat('sk', { numeric: 'auto' });
const DTF = new Intl.DateTimeFormat('sk', { dateStyle: 'medium', timeStyle: 'short' });

/** „pred 12 min", „včera", „pred 3 dňami" — pre stĺpce, kde záleží na veku, nie na presnom čase. */
export function timeAgo(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '—';
  const diff = (new Date(iso).getTime() - now) / 1000;
  const abs = Math.abs(diff);
  if (abs < 60) return 'práve teraz';
  if (abs < 3600) return RTF.format(Math.round(diff / 60), 'minute');
  if (abs < 86400) return RTF.format(Math.round(diff / 3600), 'hour');
  if (abs < 86400 * 30) return RTF.format(Math.round(diff / 86400), 'day');
  return DTF.format(new Date(iso));
}

export function formatDateTime(iso: string | null | undefined): string {
  return iso ? DTF.format(new Date(iso)) : '—';
}
